import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

const AllocationWarnings = ({ warnings }) => {
  if (!warnings || warnings.length === 0) {
    return null;
  }

  return (
    <div className="mt-2">
      {warnings.map((warning, idx) => {
        let variant = 'info';
        let content;

        if (warning.type === 'unallocated') {
          variant = 'danger';
          content = (
            <>
              <i className="bi bi-exclamation-circle-fill me-2" />
              No council member has been allocated to this candidate
            </>
          );
        } else if (warning.type === 'direct-coi') {
          variant = 'danger';
          content = (
            <>
              <i className="bi bi-exclamation-triangle-fill me-2" />
              <span className="fw-bold">{warning.councilMemberName}</span> has
              declared a DIRECT conflict of interest with this candidate
            </>
          );
        } else if (warning.type === 'same-committee') {
          variant = 'warning';
          content = (
            <>
              <i className="bi bi-exclamation-triangle-fill me-2" />
              This council member is also allocated to{' '}
              <span className="fw-bold">{warning.candidateName}</span> in this
              committee
            </>
          );
        } else {
          content = (
            <>
              <i className="bi bi-info-circle-fill me-2" />
              This council member is also allocated to{' '}
              <span className="fw-bold">{warning.candidateName}</span> in{' '}
              <span className="fw-bold">{warning.committeeName}</span>
            </>
          );
        }

        return (
          <Alert key={idx} variant={variant} className="mb-2 py-2 px-3 small">
            {content}
          </Alert>
        );
      })}
    </div>
  );
};

AllocationWarnings.propTypes = {
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([
        'unallocated',
        'same-committee',
        'different-committee',
        'direct-coi',
      ]).isRequired,
      candidateName: PropTypes.string,
      committeeName: PropTypes.string,
      councilMemberName: PropTypes.string,
      message: PropTypes.string,
      severity: PropTypes.string,
    }),
  ),
};

export default AllocationWarnings;
